import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ef88ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "quote__text",
  ref: "textElement"
}
const _hoisted_2 = {
  key: 0,
  class: "quote__name_container",
  ref: "nameElement"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "quote__line" }, null, -1))
const _hoisted_4 = { class: "quote__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_section = _resolveComponent("page-section")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_page_section, { class: "quote" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
        [_directive_sanitize, _ctx.quoteText]
      ]),
      (_ctx.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1)
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}